var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camsContainer"},[(_vm.subPage == 'Event List')?_c('div',[_c('Events')],1):_c('div',[_c('Calendar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }